import React from 'react';
import AuthPage from "@/components/ui/AuthPage";
import { MdPhoneIphone } from "react-icons/md";
import { connect } from "react-redux";
import useStyles from './MobileNotAvailableStyles';
import {
    Container,
} from '@mui/material';

interface Props {
    settings: any,
}


const MobileNotAvailable: React.FC<Props> = props => {

    const { classes } = useStyles()

    const {
        settings,
    } = props;

    return (
        <AuthPage title="Mobile applications coming soon!" icon={<MdPhoneIphone />}>
            <p>Our mobile applications are on their way!</p>
            <p>Please check back in a few days, we are currently publishing our apps and they will be available ASAP.</p>
            <p>We apologise for any inconvenience caused.</p>
        </AuthPage>
    )

}


const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

export default connect(mapStateToProps)(MobileNotAvailable);
